import { render, staticRenderFns } from "./AboutWish.vue?vue&type=template&id=58e6aecc&scoped=true"
import script from "./AboutWish.vue?vue&type=script&lang=js"
export * from "./AboutWish.vue?vue&type=script&lang=js"
import style0 from "./AboutWish.vue?vue&type=style&index=0&id=58e6aecc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58e6aecc",
  null
  
)

export default component.exports